import {observable, action , toJS} from 'mobx'
import _ from 'lodash';
import {doGet, doPost, doPut} from './AjaxRequests';
import swal from 'sweetalert';

const gerneralData = [
    {param:"DonationUse", title:"捐款用途", result:""},
    {param:"DonationAmount", title:"捐款金額", result:""},
    {param:"CardHolderName", title:"捐款人姓名", result:""},
    {param:"CardHolderIdentify", title:"身分證字號", result:""},
    {param:"CardHolderPhone", title:"聯絡電話", result:""},
    {param:"ReceiptTitle", title:"收據抬頭", result:""},
    {param:"MailReceipt", title:"收　　據", result:""},
    {param:"Address", title:"收據郵寄地址", result:""}
]

const transitionData = [
    {param:"DonationWay", title:"捐款方式", result:""},
    {param:"ShowResult", title:"授權結果", result:""},
    {param:"ShowResultContent", title:"其它授權資訊", result:""}
]





class ResultStore{
    @observable
    resultData = {
        gerneral:[],
        transition:[]
    }

    constructor(){
        this.resultData.gerneral = gerneralData
        this.resultData.transition = transitionData
    }

    getOrderData(parsed){
        let _that = this
        let fd = "OrderNo="+parsed.OrderNO
        fd = encodeURI(fd)
        fetch("https://official.kfsyscc.org/api/Finance/Authlog.aspx", {
            credentials: 'include',
            method: 'POST', // or 'PUT'
            body: fd, // data can be `string` or {object}!
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}           
        }).then(function(response) {            
            return response.json()
        }).then(function(data) {            
           _.map(_that.resultData.gerneral, (item, key)=>{
                _that.resultData.gerneral[key].result=data[item.param]
           })

           _.map(_that.resultData.transition, (item, key)=>{
            _that.resultData.transition[key].result=data[item.param]
           })
        }).catch(function(error){
            swal("系統錯誤", "請洽資訊人員", "error")
        })
    }
   
}


const resultStore = new ResultStore();

export default resultStore;
